import React from 'react';
import { Mail, Globe, Phone, ArrowRight } from 'lucide-react';
import { SlideLayout } from './SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ClosingSlide(props: SlideProps) {
  return <SlideLayout {...props} theme="brand" data-id="element-8">
      <div className="flex flex-col items-center text-center max-w-3xl mx-auto" data-id="element-9">
        <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mb-8 shadow-xl" data-id="element-10">
          <span className="text-4xl font-bold text-indigo-600" data-id="element-11">E</span>
        </div>

        <h2 className="text-5xl md:text-7xl font-bold text-white mb-8" data-id="element-12">
          Join the Revolution
        </h2>

        <p className="text-xl text-indigo-100 mb-12 max-w-2xl" data-id="element-13">
          We are raising our seed round to scale operations and bring EduAssess
          to every classroom. Let's build the future of education together.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full mb-12" data-id="element-14">
          <a href="#" className="flex flex-col items-center p-6 bg-white/10 rounded-2xl hover:bg-white/20 transition-colors backdrop-blur-sm border border-white/10" data-id="element-15">
            <Mail className="w-8 h-8 text-amber-400 mb-4" data-id="element-16" />
            <span className="text-white font-medium" data-id="element-17">
              support@eduassess.pehlai.com
            </span>
          </a>
          <a href="#" className="flex flex-col items-center p-6 bg-white/10 rounded-2xl hover:bg-white/20 transition-colors backdrop-blur-sm border border-white/10" data-id="element-18">
            <Globe className="w-8 h-8 text-emerald-400 mb-4" data-id="element-19" />
            <span className="text-white font-medium" data-id="element-20">www.eduassess.pehlai.com</span>
          </a>
          <a href="#" className="flex flex-col items-center p-6 bg-white/10 rounded-2xl hover:bg-white/20 transition-colors backdrop-blur-sm border border-white/10" data-id="element-21">
            <Phone className="w-8 h-8 text-indigo-300 mb-4" data-id="element-22" />
            <span className="text-white font-medium" data-id="element-23">+92 320 5011 329</span>
          </a>
        </div>

        <button className="bg-white text-indigo-600 px-10 py-4 rounded-full font-bold text-xl hover:bg-indigo-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 flex items-center gap-2" data-id="element-24">
          Invest Now
          <ArrowRight className="w-5 h-5" data-id="element-25" />
        </button>
      </div>
    </SlideLayout>;
}